import { DEFAULT_GETTERS } from '@/constants'

export default {
  ...DEFAULT_GETTERS,
  uploadedImage: state => state.uploadedImage,
  imageUpload: state => state.imageUpload,
  imageUploadLoading: state => state.imageUpload.loading,
  imageUploadError: state => state.imageUpload.error,
  imageUploadProgress: state => state.imageUpload.progress,
  imageUploadResult: state => state.imageUpload.result,
  uploadedImageUrl: state => state.uploadedImage.url,
  uploadedImageName: state => state.uploadedImage.name,
  imagePrompt: state => state.imagePrompt,
  imagePromptLoading: state => state.imagePrompt.loading,
  imagePromptError: state => state.imagePrompt.error,
  imagePromptText: state => state.imagePrompt.result,
  videoGeneration: state => state.videoGeneration,
  videoGenerationLoading: state => state.videoGeneration.loading,
  videoGenerationError: state => state.videoGeneration.error,
  videoGenerationResult: state => state.videoGeneration.result,
  videoGenerationTaskId: state => state.videoGeneration.taskId,
  videoPolling: state => state.videoPolling,
  videoPollingLoading: state => state.videoPolling.loading,
  videoPollingError: state => state.videoPolling.error,
  videoPollingResult: state => state.videoPolling.result,
  videoPollingStatus: state => state.videoPolling.status,
  videoPollingVideoUrl: state => state.videoPolling.videoUrl,
  videoPollingInterval: state => state.videoPolling.pollingInterval,
  selectedVideos: state => state.selectedVideos,
  selectedVideosCount: state => state.selectedVideos.length,
  formVideoGeneration: state => state.formVideoGeneration,
  formVideoGenerationLoading: state => state.formVideoGeneration.loading,
  formVideoGenerationError: state => state.formVideoGeneration.error,
  formVideoGenerationResult: state => state.formVideoGeneration.result,
  // Video source upload getters
  videoSourceUpload: state => state.videoSourceUpload,
  videoSourceUploadLoading: state => state.videoSourceUpload.loading,
  videoSourceUploadError: state => state.videoSourceUpload.error,
  videoSourceUploadProgress: state => state.videoSourceUpload.progress,
  videoSourceUploadResult: state => state.videoSourceUpload.result,
  // Video list getters
  videoList: state => state.videoList,
  videoListVideos: state => state.videoList.videos,
  videoListLoading: state => state.videoList.loading,
  videoListError: state => state.videoList.error,
  videoListPagination: state => state.videoList.pagination,
  videoListProjectId: state => state.videoList.projectId,
  // AI Analyze getters
  aiAnalyze: state => state.aiAnalyze,
  aiAnalyzeLoading: state => state.aiAnalyze.loading,
  aiAnalyzeError: state => state.aiAnalyze.error,
  aiAnalyzeResult: state => state.aiAnalyze.result,
  // Prompt suggestions getters
  promptSuggestions: state => state.promptSuggestions,
  promptSuggestionsData: state => state.promptSuggestions.data,
  promptSuggestionsLoading: state => state.promptSuggestions.loading,
  promptSuggestionsError: state => state.promptSuggestions.error,
  // Image generation getters
  imageGeneration: state => state.imageGeneration,
  imageGenerationLoading: state => state.imageGeneration.loading,
  imageGenerationError: state => state.imageGeneration.error,
  imageGenerationResult: state => state.imageGeneration.result,
  imageGenerationTaskId: state => state.imageGeneration.taskId,
  imageGenerationStatus: state => state.imageGeneration.status,
  generatedImageUrl: state => state.imageGeneration.generatedImageUrl,
  generatedImagePromptText: state => state.imageGeneration.generatedImagePromptText,
  // Image generation polling getters
  imageGenerationPolling: state => state.imageGenerationPolling,
  imageGenerationPollingLoading: state => state.imageGenerationPolling.loading,
  imageGenerationPollingError: state => state.imageGenerationPolling.error,
  imageGenerationPollingResult: state => state.imageGenerationPolling.result,
  imageGenerationPollingStatus: state => state.imageGenerationPolling.status,
  imageGenerationPollingInterval: state => state.imageGenerationPolling.pollingInterval,
  // Overall image generation process getters
  imageGenerationProcessLoading: state => state.imageGenerationProcess.loading,
}
